<app-order-request-wizard-data-summary [data]="model" />
<hr />
<app-order-request-wizard-price-summary [data]="model" />
